import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import { NavLink } from 'react-router-dom';

import Field from 'core/forms/Field';
import Form from 'core/forms/Form';
import { InputValidator, EmailPatternValidationRule, PasswordValidationRule } from 'core/validation';

import Button from 'common/components/Button';

import RecaptchaField from 'common/components/fields/RecaptchaField';
import InputTextField from 'common/components/fields/InputTextField';
import { localeStrings as strings } from 'applicationConfig';

import './login.scss';

@inject('settingsStore')
@observer
class LoginForm extends Component {
  constructor(props) {
    super(props);

    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  onFormSubmit(values) {
    return this.props.auth.signIn(values.login, values.password).catch((response) => {
      const message = (response && response.errorSummary) || strings.login.genericError;

      this.props.formStore.resetCaptcha();
      this.props.formStore.resetFormFromSubmittedState(false);
      this.props.settingsStore.showSimpleError(message);
    });
  }

  render() {
    const emailValidator = new EmailPatternValidationRule(strings.generic.errorMessages.invalidEmail);

    return (
      <Form className="login-form" onSubmit={this.onFormSubmit} formStore={this.props.formStore}>
        <div className="user-credentials">
          <div className="field-group required-field-group">
            <label className="field-group-label">{strings.login.loginLabel}</label>
            <div className="field-group-value">
              <Field component={InputTextField} type="text" name="login" placeholder={strings.login.lblLogin}>
                <InputValidator>{[ emailValidator ]}</InputValidator>
              </Field>
            </div>
          </div>
          <div className="field-group required-field-group">
            <label className="field-group-label">{strings.login.passwordLabel}</label>
            <div className="field-group-value">
              <Field component={InputTextField} type="password" name="password" placeholder={strings.login.lblPassword}>
                <InputValidator>
                  {[ new PasswordValidationRule(strings.generic.errorMessages.passwordTooWeek, 8) ]}
                </InputValidator>
              </Field>
            </div>
          </div>
          <div className="field-group">
            <label className="field-group-label" />
            <div className="field-group-value">
              <span className="link-container">
                <NavLink to="/restore-password">{strings.generic.restorePassword}</NavLink>
              </span>
            </div>
          </div>
          <div className="recaptcha-container">
            <Field component={RecaptchaField} name="captchaVerified" />
          </div>
          <div className="field-group-actions">
            <div className="actions">
              <Button
                className="btn btn-primary"
                type="submit"
                disabled={!this.props.formStore.isValid || this.props.formStore.isFormSubmitted}
              >
                <span className="button-caption">{strings.login.lblLogin}</span>
              </Button>
            </div>
          </div>
        </div>
      </Form>
    );
  }
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/containers/Login/LoginForm.jsx